import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { INewsfeedItem, ArticleStatus, ArticleType } from "./newsfeed.types"
import dayjs from "dayjs"
import { Newsfeed } from "@/models/newsfeed/newsfeed"

export interface INewsfeedRaw {
  body: string
  publishDate: string
  title: string
  type: string
}

export interface IArticleRaw {
  id: string
  title: string
  body: string
  summary?: string | null
  author: string
  type: string
  status: ArticleStatus
  publishDate: string
  createdAt: string
  updatedAt: string
}

export interface IPaginatedArticlesResponse {
  items: IArticleRaw[]
  total: number
  page: number
  pageSize: number
}

export const NewsfeedParser: IParser<INewsfeedItem, INewsfeedRaw> = {
  toDomain(data: INewsfeedRaw): INewsfeedItem {
    try {
      return new Newsfeed(
        data.body,
        dayjs(data.publishDate),
        data.title,
        data.type as ArticleType,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}

export const NewsfeedApiParser: IParser<INewsfeedItem, IArticleRaw> = {
  toDomain(data: IArticleRaw): INewsfeedItem {
    try {
      const publishDate = dayjs(data.publishDate)

      return new Newsfeed(
        data.body,
        publishDate,
        data.title,
        data.type as ArticleType,
        {
          id: data.id,
          summary: data.summary ?? undefined,
          author: data.author,
          status: data.status,
          createdAt: dayjs(data.createdAt),
          updatedAt: dayjs(data.updatedAt),
        },
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
